import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrls: ['./radio-group.component.scss'],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RadioGroupComponent),
        multi: true
      }
    ]
})

export class RadioGroupComponent extends BaseControlValueAccessor<string> {
  @Input() formControl: FormControl;
  @Input() name: string;
  @Input() options: any[];
  @Input() defaultValue:any
  @Output() changeCallback = new EventEmitter();

  onInputChange(value): void {
    this.value = value;
    this.onChange(this.value);
    if (this.changeCallback) {
      this.changeCallback.emit(this.value);
    }
  }

  showError(): boolean {
    return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
  }
}
